/* eslint-disable */
import React from "react";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { apiUrl, adminlimit } from "./Config";
import Select from "react-select";
import $ from "jquery";
import Axios from "axios";
var qs = require("qs");
var base64 = require("base-64");
import Parser from "html-react-parser";

/* stripslashes  */
export const stripslashes = function (str) {
  if (str !== "" && typeof str !== undefined && typeof str !== "undefined") {
    str = str.replace(/\\'/g, "'");
    str = str.replace(/\\"/g, '"');
    str = str.replace(/\\0/g, "\0");
    str = str.replace(/\\\\/g, "\\");
    return str;
  }
};

export const removeChar = function (str) {
  if (str && typeof str === "string" && str.trim() !== "") {
    str = str
      .normalize("NFC")
      .replace(/\uFFFD/g, "") // remove �
      .replace(/[^\x20-\x7E\n]/g, "") // remove non-printable chars
      .replace(/\s+/g, " "); // tidy up spaces
    return str;
  } else {
    return str;
  }
};
/* show Alert */
export const showAlert = function (header, message, type) {
  var icon = "";
  if (type === "success") {
    icon = "success";
  } else if (type === "success") {
    icon = "warning";
  } else {
    icon = "error";
  }
  Swal.fire({
    title: header,
    html: message,
    icon: icon,
    customClass: {
      confirmButton: "btn btn-primary waves-effect waves-light",
    },
    buttonsStyling: false,
  });
};

/* show Loader */
export const showLoader = function (divRef, type) {
  if (type === "class") {
    $("." + divRef)
      .addClass("loader-main-cls")
      .append('<span class="spinner-border spinner-border-sm loader-sub" role="status" aria-hidden="true"></span>');
  } else {
    $("#" + divRef)
      .addClass("loader-main-cls")
      .append('<span class="spinner-border spinner-border-sm loader-sub" role="status" aria-hidden="true"></span>');
  }
};
export const showContaimerLoader = function () {
  return (
    <div className="spinner2">
      <div className="cube1"></div>
      <div className="cube2"></div>
    </div>
  );
};

/* hide Loader */
export const hideLoader = function (divRef, type) {
  if (type === "class") {
    $("." + divRef).removeClass("loader-main-cls");
    $("." + divRef)
      .find(".loader-sub")
      .remove();
  } else {
    $("#" + divRef).removeClass("loader-main-cls");
    $("#" + divRef)
      .find(".loader-sub")
      .remove();
  }
};

/* int to str funtion */
export const cnvrtStr = function (d) {
  return d < 10 ? "0" + d.toString() : d.toString();
};

/* Uc first funtion */
export const jsUcfirstFun = function (string) {
  if (string !== "") {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "";
  }
};

/* Validate Int Value */
export const validateIntval = function (e) {
  const re = /[0-9]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};
export const onlyNumberDot = function (value) {
  return value.replace(/[^0-9.]/g, "");
};
export const onlyPhoneNumber = function (value) {
  return value.replace(/[^0-9+-]/g, "");
};

export const showStatus = function (status) {
  if (status === "A") {
    return <span className="btn btn-success">Active</span>;
  } else if (status === "I") {
    return <span className="btn btn-danger">InActive</span>;
  }
};

export const encodeValue = function (value) {
  if (value !== "") {
    return base64.encode(value);
  }
};
export const decodeValue = function (value) {
  if (value !== "") {
    return base64.decode(value);
  }
};

export const removeItem = function (formPayload, delUrl, sateValChange, currentPage, moduleName = "") {
  Swal.fire({
    title: "Are you sure?",
    text: "You want remove this item!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    customClass: {
      confirmButton: "btn btn-primary me-3 waves-effect waves-light",
      cancelButton: "btn btn-label-secondary waves-effect",
    },
    buttonsStyling: false,
    showLoaderOnConfirm: true,
    preConfirm: () => {
      try {
        return Axios.delete(`${apiUrl}${delUrl}/${formPayload}`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        })
          .then((res) => {
            return res.data;
          })
          .catch((e) => {
            console.log(e);
            return e?.response?.data ?? { success: false, message: e.message };
          });
      } catch (err) {
        console.log(err);
      }
    },
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    const value = result?.value ?? "";
    if (value !== "") {
      if (result.value.status === "ok") {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: result.value.message,
          customClass: {
            confirmButton: "btn btn-success waves-effect",
          },
        }).then(() => {
          sateValChange("page", currentPage, moduleName);
        });
      } else {
        Swal.fire({
          title: "Alert",
          text: result.value.message,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger waves-effect",
          },
        });
      }
    }
  });
};

/* removeEmpItem - same as removeItem, but targets the HRMS backend
   (/api/* instead of /apiv1/*) and checks its {success:true/false}
   response shape instead of Neemo's own {status:"ok"} shape. */
const empApiUrl = apiUrl.replace(/apiv1\/?$/, "api/");
export const removeEmpItem = function (formPayload, delUrl, sateValChange, currentPage, moduleName = "") {
  Swal.fire({
    title: "Are you sure?",
    text: "You want remove this item!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    customClass: {
      confirmButton: "btn btn-primary me-3 waves-effect waves-light",
      cancelButton: "btn btn-label-secondary waves-effect",
    },
    buttonsStyling: false,
    showLoaderOnConfirm: true,
    preConfirm: () => {
      try {
        return Axios.delete(`${empApiUrl}${delUrl}/${formPayload}`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        })
          .then((res) => {
            return res.data;
          })
          .catch((e) => {
            console.log(e);
            return e?.response?.data ?? { success: false, message: e.message };
          });
      } catch (err) {
        console.log(err);
      }
    },
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    const value = result?.value ?? "";
    if (value !== "") {
      if (result.value.success === true) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: result.value.message,
          customClass: {
            confirmButton: "btn btn-success waves-effect",
          },
        }).then(() => {
          sateValChange("page", currentPage, moduleName);
        });
      } else {
        Swal.fire({
          title: "Alert",
          text: result.value.message,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger waves-effect",
          },
        });
      }
    }
  });
};

/* HRMS sub-tab pagination header (Employee/View.js: family, documents, skillset, etc.) */
export const showPageView = function (currentPage, totalRecord, moduleName) {
  let start = 1;
  let end = adminlimit;
  if (currentPage > 1) {
    end = (parseInt(start) + 1) * adminlimit;
    if (end > totalRecord) {
      end = totalRecord;
    }
    start = start * adminlimit;
  } else {
    if (end > totalRecord) {
      end = totalRecord;
    }
  }
  return (
    <h3 className="card-title">
      <b>{start}</b> - <b>{end}</b> of <b>{totalRecord}</b> {moduleName}
    </h3>
  );
};

export const showDateTime = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), "dd-LLL-yyyy hh:mm a");
  }
};
export const showDate = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), "dd-LLL-yyyy");
  }
};

export const showDBDate = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), "yyyy-MM-dd");
  }
  return "";
};

export const showDBDateTime = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), "yyyy-MM-dd HH:mm") + ":00";
  }
  return "";
};

export const showDBTime = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), "HH:mm") + ":00";
  }
  return "";
};

export const validateDate = function (date) {
  if (date && date !== "-" && date !== "0000-00-00" && date !== "1970-01-01" && !isNaN(new Date(date).getTime())) {
    return new Date(date);
  } else {
    return "";
  }
};

export const isEmpty = function (value) {
  return value === "" ? "This field is required." : null;
};
export const isEmail = function (value) {
  var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  return value !== "" && value !== null && !pattern.test(value) ? "This is not a valid email." : null;
};
export const isPhone = function (value) {
  var filter = /^[0-9-+&, ]+$/;
  return value !== "" && value !== null && !filter.test(value) ? "This is not a valid phone." : null;
};
export const isNumber = function (value) {
  var regex = /^[0-9\s]*$/;
  return value !== "" && value !== null && !regex.test(value) ? "This is not a valid number." : null;
};
export const isNumberWithPoint = function (value) {
  var regex = /^[0-9.\s]*$/;
  return value !== "" && value !== null && !regex.test(value) ? "This is not a valid number." : null;
};
export const isSingleSelect = function (value) {
  if (value !== undefined) {
    if (value !== null && value !== "") {
      return Object.keys(value).length > 0 ? null : "This field is required.";
    } else {
      return "This field is required.";
    }
  }
};
export const isMultiSelect = function (value) {
  return value.length > 0 ? null : "This field is required.";
};

export const isValidPrice = function (value) {
  var regex = /^\d{0,8}(\.\d{1,4})?$/;
  return value !== "" && !regex.test(value) ? "This is not a valid price." : null;
};

export const showPageCount = function (moduleName, currentPage, totalPage, totalRecords, sateValChange, pageLimit, addParam = "") {
  return (
    <>
      <h3 className="card-title">
        Page: <b>{currentPage}</b> of <b>{totalPage}</b> {moduleName}, Total Record: {totalRecords}
      </h3>
      <div className="card-options">
        <label className="mx-3 mt-2">Page Per</label>
        <Select
          value={pageLimit} // pass the selected option
          onChange={(selectedOption) => {
            // pass both field and value
            sateValChange(`pageLimit${addParam}`, selectedOption || "", addParam);
          }}
          placeholder="Page Per"
          options={[
            { value: "10", label: "10" },
            { value: "25", label: "25" },
            { value: "50", label: "50" },
            { value: "100", label: "100" },
          ]}
        />
      </div>
    </>
  );
};
export const getMaritalStatus = function () {
  return [
    { label: "SINGLE", value: "SINGLE" },
    { label: "MARRIED", value: "MARRIED" },
    { label: "DIVORCED", value: "DIVORCED" },
    { label: "WIDOW", value: "WIDOW" },
  ];
};
export const getStateList = function () {
  const indiaStates = [
    { label: "ANDHRA PRADESH", value: "ANDHRA PRADESH" },
    { label: "ARUNACHAL PRADESH", value: "ARUNACHAL PRADESH" },
    { label: "ASSAM", value: "ASSAM" },
    { label: "BIHAR", value: "BIHAR" },
    { label: "CHHATTISGARH", value: "CHHATTISGARH" },
    { label: "GOA", value: "GOA" },
    { label: "GUJARAT", value: "GUJARAT" },
    { label: "HARYANA", value: "HARYANA" },
    { label: "HIMACHAL PRADESH", value: "HIMACHAL PRADESH" },
    { label: "JHARKHAND", value: "JHARKHAND" },
    { label: "KARNATAKA", value: "KARNATAKA" },
    { label: "KERALA", value: "KERALA" },
    { label: "MADHYA PRADESH", value: "MADHYA PRADESH" },
    { label: "MAHARASHTRA", value: "MAHARASHTRA" },
    { label: "MANIPUR", value: "MANIPUR" },
    { label: "MEGHALAYA", value: "MEGHALAYA" },
    { label: "MIZORAM", value: "MIZORAM" },
    { label: "NAGALAND", value: "NAGALAND" },
    { label: "ODISHA", value: "ODISHA" },
    { label: "PUNJAB", value: "PUNJAB" },
    { label: "RAJASTHAN", value: "RAJASTHAN" },
    { label: "SIKKIM", value: "SIKKIM" },
    { label: "TAMIL NADU", value: "TAMIL NADU" },
    { label: "TELANGANA", value: "TELANGANA" },
    { label: "TRIPURA", value: "TRIPURA" },
    { label: "UTTAR PRADESH", value: "UTTAR PRADESH" },
    { label: "UTTARAKHAND", value: "UTTARAKHAND" },
    { label: "WEST BENGAL", value: "WEST BENGAL" },
    { label: "ANDAMAN AND NICOBAR ISLANDS", value: "ANDAMAN AND NICOBAR ISLANDS" },
    { label: "CHANDIGARH", value: "CHANDIGARH" },
    { label: "DADRA AND NAGAR HAVELI AND DAMAN AND DIU", value: "DADRA AND NAGAR HAVELI AND DAMAN AND DIU" },
    { label: "DELHI", value: "DELHI" },
    { label: "JAMMU AND KASHMIR", value: "JAMMU AND KASHMIR" },
    { label: "LADAKH", value: "LADAKH" },
    { label: "LAKSHADWEEP", value: "LAKSHADWEEP" },
    { label: "PUDUCHERRY", value: "PUDUCHERRY" },
  ];
  return indiaStates;
};

export const validatedDate = function (date) {
  if (date !== "" && date !== null && date !== "1970-01-01" && date !== "0000-00-00") {
    return new Date(date);
  }
  return "";
};
export const apiDate = function (date) {
  if (date !== "" && date !== null && date !== "1970-01-01" && date !== "0000-00-00") {
    return format(new Date(date), "yyyy-MM-dd");
  }
  return "";
};

export const showDrobdownValue = function (label, value) {
  if (label !== "" && label !== null && value !== "" && value !== null) {
    return { label, value };
  }
  return "";
};

export const calculateAge = function (dobString) {
  if (!dobString || (dobString === "1970-01-01" && dobString === "0000-00-00")) return null;

  const today = new Date();
  const birth = new Date(dobString + "T00:00:00"); // avoid timezone shifts

  if (isNaN(birth.getTime())) return null;
  if (birth > today) {
    //setError('Date of birth cannot be in the future');
    return null;
  }

  // Calculate years, months, days
  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  let days = today.getDate() - birth.getDate();

  if (days < 0) {
    // borrow days from previous month
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0); // last day of prev month
    days += prevMonth.getDate();
    months -= 1;
  }

  if (months < 0) {
    months += 12;
    years -= 1;
  }

  // total days difference
  const msPerDay = 24 * 60 * 60 * 1000;
  const totalDays = Math.floor((today - birth) / msPerDay);

  return years;
};

export const calculateYMD = function (startDate, endDate) {
  if (
    startDate !== "" &&
    startDate !== null &&
    startDate != "1970-01-01" &&
    endDate !== "" &&
    endDate !== null &&
    endDate != "1970-01-01"
  ) {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);

    let years = d2.getFullYear() - d1.getFullYear();
    let months = d2.getMonth() - d1.getMonth();
    let days = d2.getDate() - d1.getDate();

    if (days < 0) {
      months--;

      // Days in the previous month
      days += new Date(
        d2.getFullYear(),
        d2.getMonth(),
        0
      ).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    // Count both start date and end date
    days++;

    const parts = [];

    if (years > 0) {
      parts.push(`${String(years).padStart(2, "0")} Year`);
    }

    if (months > 0 || years > 0) {
      parts.push(`${String(months).padStart(2, "0")} Months`);
    }

    if (days > 0) {
      parts.push(`${String(days).padStart(2, "0")} Days`);
    }

    return parts.join(" ");
  } else {
    return "";
  }
};

export const getDaysBetween = function (fromDate, toDate) {
  if (fromDate && toDate) {
    const start = new Date(fromDate);
    const end = new Date(toDate);

    const diffTime = end - start; // milliseconds
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays;
  }
};

export const getDaysBetweenDates = function (startDate, endDate) {
  var startDate_ = startDate ?? "";
  var endDate_ = endDate ?? "";
  if (
    startDate_ !== "1970-01-01" &&
    startDate_ !== "01-01-1970" &&
    startDate_ !== null &&
    startDate_ !== "" &&
    endDate_ !== "1970-01-01" &&
    endDate_ !== "01-01-1970" &&
    endDate_ !== null &&
    endDate_ !== ""
  ) {
    // Convert dates to Date objects
    const start = new Date(startDate_);
    const end = new Date(endDate_);

    // Calculate the difference in time (milliseconds)
    const timeDifference = end - start;

    // Convert time difference from milliseconds to days
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
    var addedMinus = "";
    if (start > end) {
      addedMinus = "-";
    }

    return `${addedMinus}${Math.ceil(Math.abs(dayDifference))}`; // Absolute value to handle negative differences
  } else {
    return "";
  }
};

export const normalizeValue = function (value) {
  if (value === null || value === undefined) return "";
  if (value === "null") return "";
  return value;
};

export const renderSortIcon = (field, sortKey, sortType) => {
  if (sortKey !== field) {
    return <i className="fa fa-sort" />;
  }

  return sortType === "ASC" ? <i className="fa fa-sort-alpha-asc" /> : <i className="fa fa-sort-alpha-desc" />;
};

export const showHTMLText = (text) => {
  if (text) {
    return Parser(text);
  }
  return "";
};

export const calculateStatus_ = (eocDate) => {
  if (eocDate !== "" && eocDate !== null && eocDate !== "1970-01-01") {
    const today = new Date();
    const eoc = new Date(eocDate);
    const diffTime = Math.abs(eoc - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (eoc < today) {
      return { status: "Overdue", color: "danger" };
    } else if (diffDays <= 30) {
      return { status: "Due Soon", color: "warning" };
    } else {
      return { status: "On Track", color: "success" };
    }
  }
};

export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  return token !== null && token !== undefined && token !== "";
};

export const redirectToLogin = (history, location) => {
  const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
  history.push(`/?redirect=${returnTo}`);
};

export const hasPermission = (moduleID, permission) => {
  const nemouserId = localStorage.getItem("nemouserId") || 0;
  if (nemouserId === "1") {
    return true;
  }
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const moduleData = permissions.find((item) => item.moduleID === moduleID);
  if (!moduleData) {
    return false;
  }
  return moduleData.access.includes(permission);
};

export const addModule = (moduleID, moduleName, modulePath) => {
  return (
    <div className="page-header">
      <h1 className="page-title">{moduleName}</h1>
      <div>
        {hasPermission(moduleID, "add") && (
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={`${modulePath}/add`}>
                <button className="btn btn-sm btn-success badge" type="button">
                  <i className="fa fa-plus"></i> Add New
                </button>
              </Link>
            </li>
          </ol>
        )}
      </div>
    </div>
  );
};

export const customStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
    overflowY: "auto",
    scrollbarWidth: "thin", // Firefox
  }),
};
